import { Rules } from "../construction/constructionEdit";

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace optionalForm {
  export const CONSTRUCTION = [
    {
      'display_id': 'registration_date',
      component: 'DatePickerArea',
      props: {
        format: 'yyyy-MM-dd',
        type: 'date'
      }
    },
    {
      'display_id': 'start_date',
      component: 'DatePickerArea',
      props: {
        format: 'yyyy-MM-dd',
        type: 'date'
      }
    },
    {
      'display_id': 'end_date',
      component: 'DatePickerArea',
      props: {
        format: 'yyyy-MM-dd',
        type: 'date'
      }
    },
    {
      'display_id': 'estimate_completion_date',
      component: 'DatePickerArea',
      props: {
        format: 'yyyy-MM-dd',
        type: 'date'
      }
    },
    {
      'display_id': 'completion_date',
      component: 'DatePickerArea',
      props: {
        format: 'yyyy-MM-dd',
        type: 'date'
      }
    },
    {
      'display_id': 'scheduled_completion_date',
      component: 'DatePickerArea',
      props: {
        format: 'yyyy-MM',
        type: 'month'
      }
    },
    {
      'display_id': 'billing_month',
      component: 'DatePickerArea',
      props: {
        format: 'yyyy-MM',
        type: 'month'
      }
    },
    {
      'display_id': 'customer_id',
      component: 'MasterSelectControl',
      dblookup: 'm_customer',
      props: {
        leftSideInputName: 'customer_id',
        dialogTitle: '元請選択',
        label: '元請名',
        isRightSideInputReadOnly: true
      }
    },
    {
      'display_id': 'construction_subject_id',
      component: 'MasterSelectControl',
      dblookup: 'm_construction_subject',
      props: {
        leftSideInputName: 'construction_subject_id',
        dialogTitle: '工事科目選択',
        label: '工事科目',
        isRightSideInputReadOnly: true
      }
    },
    {
      'display_id': 'sales_staff_id',
      component: 'MasterSelectSetControl',
      dblookup: 'm_staff',
      props: {
        name: 'sales_staff_id',
        dialogTitle: '担当者（営業）選択',
        outPutData: [
          {
            label: '担当者名（営業）',
            name: 'display_name',
            isReadOnly: true
          }
        ],
        isRightSideInputReadOnly: true
      }
    },
    {
      'display_id': 'construction_staff_id',
      component: 'MasterSelectSetControl',
      dblookup: 'm_staff',
      props: {
        name: 'construction_staff_id',
        dialogTitle: '担当者（工事）選択',
        outPutData: [
          {
            label: '担当者名（工事）',
            name: 'display_name',
            isReadOnly: true
          }
        ]
      }
    },
    {
      'display_id': 'construction_division_id',
      component: 'MasterSelectSetControl',
      dblookup: 'm_department',
      props: {
        name: 'construction_division_id',
        dialogTitle: '工事部門選択',
        outPutData: [
          {
            label: '工事部門',
            name: 'id',
            isReadOnly: true,
            value: ''
          },
          {
            label: '',
            name: 'name',
            isReadOnly: true,
            value: ''
          }
        ]
      }
    },
    {
      'display_id': 'estimate_order_price',
      props: {
        isCommaNumber: true
      }
    },
    {
      'display_id': 'fixed_order_price',
      props: {
        isCommaNumber: true
      }
    },
    {
      'display_id': 'files',
      props: {
        rules:Rules.RULESFILES,
        areaClass: 'basic-info__remark',
        buttonLabel:'添付ファイル 登録/参照',
        buttonSubmitColor: 'primary',
        buttonSubmitText: '実行',
        fieldId: 'files',
        modalCaution: '上記の内容が添付ファイルとして管理されます。よろしければ実行ボタンを押してください。',
        isCancel: true,
        isSubmit: true,
        isDisabled: false,
        placeholder: 'ファイルを選択してください',
        title:'添付ファイル 登録/参照',
        // 呼び出し元コンポーネント内のpropertyを設定
        appId: {
          property: true,
          name: 'projectId'
        },
        dsId: {
          property: true,
          name: 'mainDsId'
        },
        itemId: {
          property: true,
          name: 'itemId'
        },
        actionName: {
          property:true,
          name : 'itemUpdateActionId'
        },
      }
    },
    {
      'display_id': 'submit_date',
      component: 'DatePickerArea',
      props: {
        format: 'yyyy-MM-dd',
        type: 'date'
      }
    },
    {
      'display_id': 'estimate_shipping_date',
      component: 'DatePickerArea',
      props: {
        format: 'yyyy-MM-dd',
        type: 'date'
      }
    },
  ];

  export const INVOICE = [
    {
      'display_id': 'billing_date',
      component: 'DatePickerArea',
      props: {
        format: 'yyyy-MM-dd',
        type: 'date'
      }
    },
    {
      'display_id': 'date_of_issue',
      component: 'DatePickerArea',
      props: {
        format: 'yyyy-MM-dd',
        type: 'date'
      }
    },
    {
      'display_id': 'billing_amount',
      props: {
        isCommaNumber: true
      }
    }
  ];

  export const EXPECTEDCOSTINPUTMATERIALCOST = [
    {
      'display_id': 'material_id',
      component: 'MasterSelectButton',
      dblookup: 'm_material',
      props: {
        name: 'material_id',
        labelText: '',
        dialogTitle: '材料選択'
      }
    },
    {
      'display_id': 'supplier_id',
      component: 'MasterSelectButton',
      dblookup: 'm_supplier',
      props: {
        name: 'supplier_id',
        labelText: '',
        dialogTitle: '仕入先選択'
      }
    },
    {
      'display_id': 'quantity',
      component: 'InputUnitPriceQuantityCalculation',
      dblookup: 'm_unit',
      dataKeyColum: 'id',
      valueColum: 'unit',
      props: {
        name: 'quantity;unit_price;unit;',
        quantityLabelName: '数量',
        unitLabelName: '単位',
        unitPriceLabelName: '単価',
        amountLabelName: '金額',
        quantityLabelText: '数量',
        unitLabelText: '単位',
        unitPriceLabelText: '単価',
        amountLabelText: '金額',
        isQuantityCommaNumber: true,
        isUnitPriceCommaNumber: true,
        isAmountCommaNumber: true,
        value: ''
      }
    }
  ];

  export const EXPECTEDCOSTINPUTLABORCOST = [
    {
      'display_id': 'work_type',
      component: 'InputArea',
      props: {
        labelName:'工種〈労務費〉',
        labelText: '工種〈労務費〉',
        name: 'work_type'
      }
    },
    {
      'display_id': 'subcontractor_id',
      component: 'MasterSelectButton',
      dblookup: 'm_subcontractor',
      props: {
        name: 'subcontractor_id',
        labelText: '',
        dialogTitle: '外注先選択'
      }
    },
    {
      'display_id': 'quantity',
      component: 'InputUnitPriceQuantityCalculation',
      dblookup: 'm_unit',
      dataKeyColum: 'id',
      valueColum: 'unit',
      props: {
        name: 'quantity;unit_price;unit;',
        quantityLabelName: '数量',
        unitLabelName: '単位',
        unitPriceLabelName: '単価',
        amountLabelName: '金額',
        quantityLabelText: '数量',
        unitLabelText: '単位',
        unitPriceLabelText: '単価',
        amountLabelText: '金額',
        isQuantityCommaNumber: true,
        isUnitPriceCommaNumber: true,
        isAmountCommaNumber: true,
        value: ''
      }
    }
  ];

  export const EXPECTEDCOSTINPUTCONSUMABLECOST = [
    {
      'display_id': 'account_title',
      component: 'InputArea',
      props: {
        labelName:'〈消耗・その他経費〉',
        labelText: '〈消耗・その他経費〉',
        name: 'account_title'
      }
    },
    {
      'display_id': 'quantity',
      component: 'InputUnitPriceQuantityCalculation',
      dblookup: 'm_unit',
      dataKeyColum: 'id',
      valueColum: 'unit',
      props: {
        name: 'quantity;unit_price;unit;',
        quantityLabelName: '数量',
        unitLabelName: '単位',
        unitPriceLabelName: '単価',
        amountLabelName: '金額',
        quantityLabelText: '数量',
        unitLabelText: '単位',
        unitPriceLabelText: '単価',
        amountLabelText: '金額',
        isQuantityCommaNumber: true,
        isUnitPriceCommaNumber: true,
        isAmountCommaNumber: true,
        value: ''
      }
    }
  ];

  export const FIXEDCOSTINPUTMATERIALCOST = [
    {
      'display_id': 'material_id',
      component: 'MasterSelectButton',
      dblookup: 'm_material',
      props: {
        name: 'material_id',
        labelText: '',
        dialogTitle: '材料選択'
      }
    },
    {
      'display_id': 'supplier_id',
      component: 'MasterSelectButton',
      dblookup: 'm_supplier',
      props: {
        name: 'supplier_id',
        labelText: '',
        dialogTitle: '仕入先選択'
      }
    },
    {
      'display_id': 'quantity',
      component: 'InputUnitPriceQuantityCalculation',
      dblookup: 'm_unit',
      dataKeyColum: 'id',
      valueColum: 'unit',
      props: {
        name: 'quantity;unit_price;unit;',
        quantityLabelName: '数量',
        unitLabelName: '単位',
        unitPriceLabelName: '単価',
        amountLabelName: '金額',
        quantityLabelText: '数量',
        unitLabelText: '単位',
        unitPriceLabelText: '単価',
        amountLabelText: '金額',
        isQuantityCommaNumber: true,
        isUnitPriceCommaNumber: true,
        isAmountCommaNumber: true,
        value: ''
      }
    },
    {
      'display_id': 'billing_month',
      component: 'DatePickerArea',
      props: {
        format: 'yyyy-MM',
        type: 'month'
      }
    }
  ];

  export const FIXEDCOSTINPUTLABORCOST = [
    {
      'display_id': 'work_type',
      component: 'InputArea',
      props: {
        'labelName':'工種〈労務費〉',
        'labelText': '工種〈労務費〉',
        'name': 'work_type'
      }
    },
    {
      'display_id': 'subcontractor_id',
      component: 'MasterSelectButton',
      dblookup: 'm_subcontractor',
      props: {
        name: 'subcontractor_id',
        labelText: '',
        dialogTitle: '外注先選択'
      }
    },
    {
      'display_id': 'quantity',
      component: 'InputUnitPriceQuantityCalculation',
      dblookup: 'm_unit',
      dataKeyColum: 'id',
      valueColum: 'unit',
      props: {
        name: 'quantity;unit_price;unit;',
        quantityLabelName: '数量',
        unitLabelName: '単位',
        unitPriceLabelName: '単価',
        amountLabelName: '金額',
        quantityLabelText: '数量',
        unitLabelText: '単位',
        unitPriceLabelText: '単価',
        amountLabelText: '金額',
        isQuantityCommaNumber: true,
        isUnitPriceCommaNumber: true,
        isAmountCommaNumber: true,
        value: ''
      }
    },
    {
      'display_id': 'billing_month',
      component: 'DatePickerArea',
      props: {
        format: 'yyyy-MM',
        type: 'month'
      }
    },
  ];

  export const FIXEDCOSTINPUTCONSUMABLECOST = [
    {
      'display_id': 'account_title',
      component: 'InputArea',
      props: {
        'labelName':'〈消耗・その他経費〉',
        'labelText': '〈消耗・その他経費〉',
        'name': 'account_title'
      }
    },
    {
      'display_id': 'quantity',
      component: 'InputUnitPriceQuantityCalculation',
      dblookup: 'm_unit',
      dataKeyColum: 'id',
      valueColum: 'unit',
      props: {
        name: 'quantity;unit_price;unit;',
        quantityLabelName: '数量',
        unitLabelName: '単位',
        unitPriceLabelName: '単価',
        amountLabelName: '金額',
        quantityLabelText: '数量',
        unitLabelText: '単位',
        unitPriceLabelText: '単価',
        amountLabelText: '金額',
        isQuantityCommaNumber: true,
        isUnitPriceCommaNumber: true,
        isAmountCommaNumber: true,
        value: ''
      }
    },
    {
      'display_id': 'billing_month',
      component: 'DatePickerArea',
      props: {
        format: 'yyyy-MM',
        type: 'month'
      }
    }
  ];
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace masterForm {
  export const MASTERCONTROLCOLUMS: { [k: string]: Array<{ [k: string]: string }> } = {
    'm_customer': [
      { value: 'id', text: '取引先ID', width: '20%' },
      { value: 'name', text: '元請名', width: '80%' }
    ],
    'm_staff': [
      { value: 'id', text: '担当者ID', width: '20%' },
      { value: 'display_name', text: '担当者名', width: '80%' }
    ],
    'm_department': [
      { value: 'id', text: '工事部門ID', width: '20%' },
      { value: 'name', text: '工事部門名', width: '80%' }
    ],
    'm_construction_subject' : [
      { value: 'id', text: '工事科目ID', width: '20%' },
      { value: 'name', text: '工事科目名', width: '80%' }
    ],
    'm_material' : [
      { value: 'id', text: '材料ID', width: '20%' },
      { value: 'name', text: '材料名', width: '40%' },
      { value: 'standard', text: '規格', width: '40%' }
    ],
    'm_supplier' : [
      { value: 'id', text: '仕入先ID', width: '20%' },
      { value: 'name', text: '仕入先名', width: '80%' }
    ],
    'm_subcontractor' : [
      { value: 'id', text: '外注先ID', width: '20%' },
      { value: 'name', text: '外注先名', width: '80%' }
    ]
  };
}

export const optionalFormInVoice = optionalForm.INVOICE;
export const optionalFormExpectedCostInputMaterialCost = optionalForm.EXPECTEDCOSTINPUTMATERIALCOST;
export const optionalFormExpectedCostInputLaborCost = optionalForm.EXPECTEDCOSTINPUTLABORCOST;
export const optionalFormExpectedCostInputConsumableCost = optionalForm.EXPECTEDCOSTINPUTCONSUMABLECOST;
export const optionalFormFixedCostInputMaterialCost = optionalForm.FIXEDCOSTINPUTMATERIALCOST;
export const optionalFormFixedCostInputLaborCost = optionalForm.FIXEDCOSTINPUTLABORCOST;
export const optionalFormFixedCostInputConsumableCost = optionalForm.FIXEDCOSTINPUTCONSUMABLECOST;

export const optionalFormConstruction = optionalForm.CONSTRUCTION;
export const masterControlColums = masterForm.MASTERCONTROLCOLUMS;

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace formDefine {
  // APIから取得したDatatypeと使用するべきモジュールコンポーネントをマッピング用
  export const MAPPING: { [k: string]: { component: string; props: string[] } } = {
    text: {
      component: 'InputArea',
      props: ['labelName', 'labelText', 'name']
    },
    number: {
      component: 'InputArea',
      props: ['labelName', 'labelText', 'name', 'inputType']
    },
    select: {
      component: 'SelectArea',
      props: ['label', 'selectData', 'name']
    },
    textarea: {
      component: 'TextArea',
      props: ['labelName', 'labelText', 'name']
    },
    datetime: {
      component: 'DatePickerArea',
      props: ['labelName', 'labelText', 'name']
    },
    radio: {
      component: 'SelectArea',
      props: ['label', 'selectData', 'name']
    },
    file: {
      component: 'FileManager',
      props: ['label', 'selectData', 'name']
    }
  };
  // 使用するモジュールコンポーネントの各propsにセットするAPIの返り値をマッピング
  export const settingPropsValue: { [k: string]: string } = {
    labelName: 'display_id',
    labelText: 'name',
    label: 'name',
    name: 'display_id',
    selectData: 'options',
    inputType: 'dataType'
  };
}

export const formMapDefineData = formDefine.MAPPING;
export const formMapPropsDefineData = formDefine.settingPropsValue;

// ファイル関連
export const fileActionDefautMessage = {
  upload: {
    success: 'ファイルを登録しました。',
    fail   : 'ファイルの登録に失敗しました。'
  },
  delete: {
    success: 'ファイルを削除しました。',
    fail   : 'ファイルの削除に失敗しました。'
  },
  download: {
    success: 'ファイルをダウンロードしました。',
    fail   : 'ファイルのダウンロードに失敗しました。'
  }
}
export const buttonLabel: {[k: string]: string} = {
  delete: 'ファイル削除',
  download: 'ファイルダウンロード'
}
export const tableColumn: {[k: string]: any}  = {
  columns: [
    {text: 'ファイル名',value: 'name'},
    {text: '', value: 'file_id', sortable: false, width: 70}
  ],
  buttonItems: [
    { name: 'file_id', icon: 'mdi-delete-outline', class: 'btn-icon--noframe', disabled: false }
  ]
}